<template>
    <div class="block" v-if="this.$store.state.isMobile">
        <!--        <span class="demonstration">默认 Hover 指示器触发</span>-->
        <el-carousel  height="90px"  indicator-position="none">
            <el-carousel-item v-for="item in list" >
                <div class="small">{{ item.eng }}</div>
                <br>
                <div class="small">{{ item.chi }}</div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    export default {
        name: "CarouselM",
        data() {
            return {
                list:[
                    {
                        eng: 'I WOULD RATHER',
                        chi: '人有冲天之志'
                    },
                    {
                        eng: 'I WOULD RATHER',
                        chi: '非运不可自通'
                    },

                ]
                // list: [
                //     {
                //         eng: 'I WOULD RATHER',
                //         chi: '我宁愿'
                //     },
                //     {
                //         eng: 'AIM FOR THE STARS',
                //         chi: '瞄准星星'
                //     },
                //     {
                //         eng: 'AND NOT HIT THEM',
                //         chi: '却击不中他们'
                //     },
                //     {
                //         eng: 'THEN TO NOT AIM AT ALL',
                //         chi: '也不愿没有目标'
                //     },
                //     {
                //         eng: 'I WOULD RATHER GO AFTER IT',
                //         chi: '我宁愿去追逐梦想'
                //     },
                //     {
                //         eng: 'AND NOT GET IT',
                //         chi: '却得不到它，'
                //     },
                //     {
                //         eng: 'THEN NOT GO AFTER IT AT ALL',
                //         chi: '也不愿不曾追逐。'
                //     },
                //     {
                //         eng: 'I\'D RATHER TRY AND FAIL',
                //         chi: '我宁愿去尝试、去失败，'
                //     },
                //     {
                //         eng: 'THEN NOT TRY AT ALL',
                //         chi: '我不想活着的每一天'
                //     },
                //     {
                //         eng: 'WONDER WHAT WOULD HAVE HAPPEN',
                //         chi: '都在幻想如果我当初'
                //     },
                //     {
                //         eng: 'HAD I DONE MORE',
                //         chi: '付出了更多努力,'
                //     },
                //     {
                //         eng: 'WITH MY LIFE',
                //         chi: '现在会是怎么样。'
                //     },
                //     {
                //         eng: 'I\'M GONNA GO FOR IT',
                //         chi: '我会去放手追逐，'
                //     },
                //     {
                //         eng: 'COME HELL',
                //         chi: '无论刀山'
                //     },
                //     {
                //         eng: 'OR HIGH WATER',
                //         chi: '火海，'
                //     },
                //
                //     {
                //         eng: 'I\'M GOING AFTER',
                //         chi: '我都会去追逐'
                //     },
                //     {
                //         eng: 'MY DESTINY',
                //         chi: '我的命运。'
                //     },
                //     {
                //         eng: 'YOU CAN\'T STROLL AFTER YOUR DESTINY',
                //         chi: '你不能朝着梦想漫步，'
                //     },
                //     {
                //         eng: 'YOU CAN\'T WALK AFTER YOUR DESTINY',
                //         chi: '你不能朝着梦想行走，'
                //     },
                //     {
                //         eng: 'YOU GOTTA RUN',
                //         chi: '你要向它狂奔！'
                //     },


                    // '记得高中第一节物理课，物理老师就在黑板上写下了“分析万物之理，判天地之美。”感谢那位老师让我在之后的三年进一步的领略了物理之美。',
                    // '只有那些疯狂到认为自己能改变世界的人，才能真正的改变世界',
                    // '我不想等我老了，再来懊悔，如果当初我为何不赌一把，我',
                    // '444'
                // ]
            }
        }
    }

</script>

<style scoped>
    .el-carousel__item div {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 35px;
        margin: 0;
    }
    .small{
        position: relative;
        text-align: center;
        font-size:  2rem;
        margin-left: 4rem;
        margin-right: 4rem;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

</style>